/**
 * Job Single Page Scripts
 * Handles Swiper initialization for similar jobs carousel
 */

(function() {
    'use strict';

    let similarJobsSwiper = null;
    let initAttempts = 0;
    const maxAttempts = 20;

    function initSimilarJobsSlider(resetAttempts) {
        if (resetAttempts) {
            initAttempts = 0;
        }
        initAttempts++;

        // Wait for Swiper to be available
        if (typeof Swiper === 'undefined') {
            if (initAttempts < maxAttempts) {
                setTimeout(function() {
                    initSimilarJobsSlider(false);
                }, 100);
            } else {
                console.error('Swiper failed to load after multiple attempts');
            }
            return;
        }

        // Initialize similar jobs slider
        const similarJobsSection = document.querySelector('.similar-jobs');
        if (!similarJobsSection) {
            if (initAttempts < maxAttempts) {
                setTimeout(function() {
                    initSimilarJobsSlider(false);
                }, 100);
            }
            return;
        }

        const slider = similarJobsSection.querySelector('.similar-jobs__slider');
        const prevBtn = similarJobsSection.querySelector('.blog-recent__nav-btn--prev');
        const nextBtn = similarJobsSection.querySelector('.blog-recent__nav-btn--next');

        if (!slider) {
            return;
        }

        // Check if slider already has slides
        const slides = slider.querySelectorAll('.swiper-slide');
        if (slides.length === 0) {
            return;
        }

        // Destroy existing instance if any
        if (slider.swiper) {
            slider.swiper.destroy(true, true);
            similarJobsSwiper = null;
        }

        try {
            similarJobsSwiper = new Swiper(slider, {
                slidesPerView: 1,
                spaceBetween: 24,
                loop: false,
                speed: 600,
                grabCursor: true,
                watchOverflow: true,
                allowTouchMove: true,
                navigation: {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                    disabledClass: 'blog-recent__nav-btn--disabled',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.15,
                        spaceBetween: 16,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                    },
                },
                on: {
                    init: function() {
                        updateNavButtons();
                    },
                    slideChange: function() {
                        updateNavButtons();
                    },
                    reachEnd: function() {
                        updateNavButtons();
                    },
                    reachBeginning: function() {
                        updateNavButtons();
                    },
                },
            });

            function updateNavButtons() {
                if (!similarJobsSwiper) return;

                if (prevBtn) {
                    if (similarJobsSwiper.isBeginning) {
                        prevBtn.classList.add('blog-recent__nav-btn--disabled');
                        prevBtn.disabled = true;
                    } else {
                        prevBtn.classList.remove('blog-recent__nav-btn--disabled');
                        prevBtn.disabled = false;
                    }
                }
                if (nextBtn) {
                    if (similarJobsSwiper.isEnd) {
                        nextBtn.classList.add('blog-recent__nav-btn--disabled');
                        nextBtn.disabled = true;
                    } else {
                        nextBtn.classList.remove('blog-recent__nav-btn--disabled');
                        nextBtn.disabled = false;
                    }
                }
            }
        } catch (error) {
            console.error('Error initializing similar jobs slider:', error);
        }
    }

    // Make function globally available
    window.initSimilarJobsSlider = initSimilarJobsSlider;

    // Wait for window load to ensure all scripts are loaded
    if (window.addEventListener) {
        window.addEventListener('load', function() {
            setTimeout(function() {
                initSimilarJobsSlider(false);
            }, 100);
        });
    }

    // Also try when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            setTimeout(function() {
                initSimilarJobsSlider(false);
            }, 200);
        });
    } else {
        setTimeout(function() {
            initSimilarJobsSlider(false);
        }, 200);
    }

    // Job Overview Mobile Panel Toggle
    function initJobOverviewMobile() {
        const sidebar = document.querySelector('.single-job__sidebar');
        const triggerBtn = document.querySelector('.job-overview__mobile-trigger');
        const overlay = document.querySelector('.single-job__sidebar-overlay');
        const closeBtn = document.querySelector('.job-overview__close');

        if (!sidebar) {
            return;
        }

        // Initialize panel state on mobile
        function initPanelState() {
            if (window.innerWidth <= 782) {
                // Mobile: hide panel by default, show trigger button
                if (!sidebar.classList.contains('is-open')) {
                    sidebar.style.display = 'none';
                    sidebar.style.visibility = 'hidden';
                    sidebar.style.transform = 'translateY(100%)';
                    sidebar.style.opacity = '0';
                }
                if (triggerBtn) {
                    triggerBtn.style.display = 'block';
                    triggerBtn.classList.remove('is-hidden');
                }
                if (overlay) {
                    overlay.classList.remove('is-open');
                }
                document.body.style.overflow = '';
            } else {
                // Desktop: show panel normally
                sidebar.style.display = '';
                sidebar.style.visibility = '';
                sidebar.style.transform = '';
                sidebar.style.opacity = '';
                sidebar.classList.remove('is-open');
                if (triggerBtn) {
                    triggerBtn.style.display = 'none';
                    triggerBtn.classList.remove('is-hidden');
                }
                if (overlay) {
                    overlay.classList.remove('is-open');
                }
                document.body.style.overflow = '';
            }
        }

        function openPanel() {
            if (window.innerWidth > 782) {
                return; // Don't open on desktop
            }
            // Set display and visibility first
            sidebar.style.display = 'block';
            sidebar.style.visibility = 'visible';
            // Force reflow to ensure display is applied before transform
            void sidebar.offsetHeight;
            // Then add class and transform
            sidebar.classList.add('is-open');
            sidebar.style.transform = 'translateY(0)';
            sidebar.style.opacity = '1';
            if (overlay) {
                overlay.classList.add('is-open');
            }
            document.body.style.overflow = 'hidden';
            if (triggerBtn) {
                triggerBtn.classList.add('is-hidden');
            }
        }

        function closePanel() {
            sidebar.classList.remove('is-open');
            sidebar.style.transform = 'translateY(100%)';
            sidebar.style.opacity = '0';
            setTimeout(function() {
                if (!sidebar.classList.contains('is-open')) {
                    sidebar.style.display = 'none';
                    sidebar.style.visibility = 'hidden';
                }
            }, 300);
            if (overlay) {
                overlay.classList.remove('is-open');
            }
            document.body.style.overflow = '';
            if (triggerBtn) {
                triggerBtn.classList.remove('is-hidden');
            }
        }

        // Initialize panel state
        initPanelState();

        // Open panel handler
        if (triggerBtn) {
            triggerBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                openPanel();
            });
        }

        // Close button handler
        if (closeBtn) {
            closeBtn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                closePanel();
            });
        }

        // Close panel when clicking overlay
        if (overlay) {
            overlay.addEventListener('click', function(e) {
                if (e.target === overlay) {
                    closePanel();
                }
            });
        }

        // Prevent panel content clicks from closing
        const jobOverview = sidebar.querySelector('.job-overview');
        if (jobOverview) {
            jobOverview.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        }

        // Handle window resize
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                initPanelState();
            }, 250);
        });
    }

    // Initialize mobile panel on DOM ready
    function initMobilePanel() {
        setTimeout(function() {
            initJobOverviewMobile();
        }, 100);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMobilePanel);
    } else {
        initMobilePanel();
    }

    // Also initialize on window load to ensure everything is ready
    if (window.addEventListener) {
        window.addEventListener('load', function() {
            setTimeout(function() {
                initJobOverviewMobile();
            }, 200);
        });
    }

    // Apply modal: move label text into placeholders and hide labels (form UX)
    function applyModalFormPlaceholders(form) {
        if (!form) {
            return;
        }
        var labels = form.querySelectorAll('.matador-label label[for]');
        labels.forEach(function(label) {
            var forId = label.getAttribute('for');
            var text = (label.textContent || '').trim().replace(/\s*:\s*$/, '');
            if (!text || !forId) {
                return;
            }
            var control = form.querySelector('#' + CSS.escape(forId));
            if (!control) {
                return;
            }
            if (control.tagName === 'INPUT' || control.tagName === 'TEXTAREA') {
                control.setAttribute('placeholder', text);
            }
        });
    }

    // Apply modal: open on "Apply to this position", close on overlay / X / Escape
    function initApplyModal() {
        const modal = document.getElementById('evona-apply-modal');
        const trigger = document.getElementById('evona-apply-modal-trigger');
        const overlay = document.getElementById('evona-apply-modal-overlay');
        const closeBtn = document.getElementById('evona-apply-modal-close');

        if (!modal || !trigger) {
            return;
        }

        var form = modal.querySelector('#matador-application-form');
        applyModalFormPlaceholders(form);

        function openModal() {
            modal.setAttribute('aria-hidden', 'false');
            if (trigger) {
                trigger.setAttribute('aria-expanded', 'true');
            }
            document.body.classList.add('evona-modal-open');

            var firstFocusable = modal.querySelector('button, [href], input:not([type="hidden"]), select, textarea');
            if (firstFocusable) {
                setTimeout(function() {
                    firstFocusable.focus();
                }, 50);
            }
        }

        function closeModal() {
            modal.setAttribute('aria-hidden', 'true');
            if (trigger) {
                trigger.setAttribute('aria-expanded', 'false');
                trigger.focus();
            }
            document.body.classList.remove('evona-modal-open');
        }

        trigger.addEventListener('click', function(e) {
            e.preventDefault();
            openModal();
        });

        if (closeBtn) {
            closeBtn.addEventListener('click', function(e) {
                e.preventDefault();
                closeModal();
            });
        }

        if (overlay) {
            overlay.addEventListener('click', closeModal);
        }

        document.addEventListener('keydown', function(e) {
            if (e.key !== 'Escape') {
                return;
            }
            if (modal.getAttribute('aria-hidden') === 'true') {
                return;
            }
            closeModal();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initApplyModal);
    } else {
        initApplyModal();
    }
})();
